import { render, staticRenderFns } from "./cooperationBranchDialog.vue?vue&type=template&id=2ce80940&"
import script from "./cooperationBranchDialog.vue?vue&type=script&lang=js&"
export * from "./cooperationBranchDialog.vue?vue&type=script&lang=js&"
import style0 from "./cooperationBranchDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce80940')) {
      api.createRecord('2ce80940', component.options)
    } else {
      api.reload('2ce80940', component.options)
    }
    module.hot.accept("./cooperationBranchDialog.vue?vue&type=template&id=2ce80940&", function () {
      api.rerender('2ce80940', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/cooperationBranchDialog.vue"
export default component.exports